import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CalculatorPage from './pages/CalculatorPage';
import DashboardPage from './pages/DashboardPage';
import WalletPage from './pages/WalletPage';
import RelatoriosPage from './pages/RelatoriosPage';
import RastreioPage from './pages/RastreioPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ShipmentsPage from './pages/ShipmentsPage';
import ConfiguracoesPage from './pages/ConfiguracoesPage';
import ClientesPage from './pages/ClientesPage';
import PerfilPage from './pages/PerfilPage';
import RegrasEnvioPage from './pages/RegrasEnvioPage';
import { Toaster } from './components/ui/toaster';
import InstallPrompt from './components/InstallPrompt';
import { AuthProvider } from './context/AuthContext';
import { registrarVisita } from './lib/api';

function App() {
  useEffect(() => {
    try {
      if (!sessionStorage.getItem('inn_visita')) { sessionStorage.setItem('inn_visita', '1'); registrarVisita(); }
    } catch { /* noop */ }
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/cadastro" element={<RegisterPage />} />
            <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
            <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
            <Route path="/calcular" element={<CalculatorPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/carteira" element={<WalletPage />} />
            <Route path="/envios" element={<ShipmentsPage />} />
            <Route path="/relatorios" element={<RelatoriosPage />} />
            <Route path="/rastreio" element={<RastreioPage />} />
            <Route path="/admin" element={<Navigate to="/configuracoes" replace />} />
            <Route path="/configuracoes" element={<ConfiguracoesPage />} />
            <Route path="/clientes" element={<ClientesPage />} />
            <Route path="/perfil" element={<PerfilPage />} />
            <Route path="/regras-de-envio" element={<RegrasEnvioPage />} />
            <Route path="/admin/correios" element={<Navigate to="/configuracoes" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster />
      <InstallPrompt />
    </div>
  );
}

export default App;
